import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import { useAggregateAPIOperationStatus, useMutation } from "@octopusdeploy/octopus-react-client";
import type { GitRef } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { useState } from "react";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { MarkdownEditor, Text } from "~/components/form/index";
export function AddProjectTemplateDialog({ gitRef, onComplete }: {
    gitRef: GitRef;
    onComplete: () => void;
}) {
    const [name, setName] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const navigation = useSpaceAwareNavigation();
    const { execute: addProjectTemplate } = useMutation({
        name: "Add Project Template",
        action: async (repository) => await repository.ProjectTemplates.add({ Name: name, Description: description, ChangeDescription: `Add project template '${name}'` }, gitRef),
        afterComplete: async (_, output) => {
            navigation.navigate(links.projectTemplatesPage.generateUrl({ gitRef: output.GitRef }));
            onComplete();
        },
    });
    const { isInProgress, errors } = useAggregateAPIOperationStatus();
    const hasMissingValues = !name;
    return (<SaveDialogLayout title={"Add Project Template"} busy={isInProgress} errors={errors} onSaveClick={async () => {
            await addProjectTemplate();
            return true;
        }} saveButtonLabel={"Add"} busyButtonLabel={"Adding..."} saveButtonDisabled={hasMissingValues}>
            <div className={styles.content}>
                <Text value={name} onChange={(value) => setName(value)} label="Name"/>
                <MarkdownEditor value={description} label="Description" onChange={(value) => setDescription(value)}/>
            </div>
        </SaveDialogLayout>);
}
const styles = {
    content: css({
        display: "flex",
        flexDirection: "column",
        gap: space[8],
    }),
};
